var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
    'a-badge fw-400 primary-green fs-12 px-4 white--text',
    {
      'is-ribbon': _vm.ribbon
    }
  ],domProps:{"textContent":_vm._s(_vm.label)}})
}
var staticRenderFns = []

export { render, staticRenderFns }